import { render } from "./CheckboxSelect.vue?vue&type=template&id=4b3ca1ec"
import script from "./CheckboxSelect.vue?vue&type=script&lang=js"
export * from "./CheckboxSelect.vue?vue&type=script&lang=js"
script.render = render

export default script